import IconClose from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton'
import { FileInfo } from 'components/FileInfo'
import { memo, MouseEvent } from 'react'
import { FormattedMessage } from 'react-intl'
import { MediaItemState } from 'services/compose/state'
import { MediaTileCallbacks, mediaElementId, mediaElementSelector, useFileInfoCallbacks, useSortableWrapperProps } from './gridItem'
import styles from './MediaPreview.pcss'

export type ExternalImageGridItemProps = MediaTileCallbacks & {
  data: MediaItemState,
  featured: boolean,
  onRemove: (name: string, id: string) => void,
  onEdit: (id: string) => void,
  onExpand: (url: string, selector: string) => void
}

/** Tile for an image the composer only knows by url — nothing left to upload. */
export const ExternalImageGridItem = memo(function ExternalImageGridItem(props: ExternalImageGridItemProps) {
  const fileId = props.data.id
  const wrapperProps = useSortableWrapperProps(fileId)
  const { metadataLoaded, sizeFetched } = useFileInfoCallbacks(fileId, props)

  const remove = (e: MouseEvent) => {
    e.stopPropagation()
    props.onRemove('', fileId)
  }

  const edit = (e: MouseEvent) => {
    e.stopPropagation()
    props.onEdit(fileId)
  }

  const expand = (e: MouseEvent) => {
    e.stopPropagation()
    if (props.data.url) {
      props.onExpand(props.data.url, mediaElementSelector(fileId))
    }
  }

  return (
    <div className={styles['file-box-wrapper']} data-testid="preview-ext-image" {...wrapperProps}>
      {props.featured && (
        <div className={styles['label-featured']}>
          <FormattedMessage id="label.generic.featured" />
        </div>
      )}
      <div className={`${styles['file-box']} ${styles.ext}`} onClick={expand}>
        <IconButton size="small" className={styles['btn-remove']} onClick={remove}>
          <IconClose className={styles.icon} />
        </IconButton>
        <IconButton size="small" className={styles['btn-edit']} onClick={edit}>
          <EditIcon className={styles.icon} />
        </IconButton>
        <img className={styles.image} src={props.data.url} alt="" data-testid={mediaElementId(fileId)} />
      </div>
      <FileInfo
        fileUrl={props.data.url}
        className={styles['file-box-footer']}
        onSizeFetched={sizeFetched}
        onMetadataLoaded={metadataLoaded}
      />
    </div>
  )
})
